import { apiAction, API_ERROR, API_SUCCESS } from "../dux/api";
import { apiCallComplete, apiCallStart } from "../dux/apiStatus";
import { MARK_DAYS_OFF_HOLIDAY } from "../dux/markDaysOffHoliday";
import { fetchHolidayDates } from "../dux/bookNow";
import { openSnackbar } from "../dux/snackbar";
import { getHolidayUpdateUrl } from "../helpers/apiEndPoints";

const markDaysOffHoliday =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);

    if (action.type === MARK_DAYS_OFF_HOLIDAY) {
      const { dateArr, sport, location } = action.payload;
      next(apiCallStart({ api: "markOffHoliday" }));
      next(
        apiAction({
          url: getHolidayUpdateUrl(),
          feature: MARK_DAYS_OFF_HOLIDAY,
          method: "POST",
          data: {
            sport: sport,
            location: location,
            dates: dateArr,
          },
          meta: { sport, location },
        })
      );
    }

    if (action.type === `${MARK_DAYS_OFF_HOLIDAY} ${API_SUCCESS}`) {
      next(apiCallComplete({ api: "markOffHoliday" }));

      const response = action.payload.response || action.payload;
      const added = response.added || 0;
      const deleted = response.deleted || 0;

      let message = "Holiday dates updated successfully.";
      if (added > 0 && deleted > 0) {
        message = `${added} holiday(s) added and ${deleted} holiday(s) removed successfully.`;
      } else if (added > 0) {
        message = `${added} holiday(s) added successfully.`;
      } else if (deleted > 0) {
        message = `${deleted} holiday(s) removed successfully.`;
      }

      next(
        openSnackbar({
          message: message,
        })
      );

      // Refresh holiday dates after update using the new API
      dispatch(
        fetchHolidayDates({
          sport: action.meta.sport,
          location: action.meta.location,
        })
      );
    }

    if (action.type === `${MARK_DAYS_OFF_HOLIDAY} ${API_ERROR}`) {
      next(apiCallComplete({ api: "markOffHoliday" }));

      const errorPayload = action.payload?.response || action.payload || {};
      const message =
        errorPayload.message ||
        errorPayload.error ||
        "Failed to update holiday dates. Please try again.";

      next(
        openSnackbar({
          message: typeof message === "string" ? message : "Failed to update holiday dates. Please try again.",
        })
      );
    }
  };

export default markDaysOffHoliday;
